import type { Statistics } from './models/api';
import type { GetDataForDashboardQueryResult } from './models/mainservice';
import { protectedApiClient, protectedApiClientV2 } from './support/baseApiClients';

export default {
  getMainStatistics: async () => {
    const result = await protectedApiClient.get<GetDataForDashboardQueryResult>('/dashboard');
    return result.data;
  },
  getCompanyStatistics: async () => {
    const result = await protectedApiClientV2.get<Statistics>('/statistics/company');
    return result.data;
  }
  // editCompanyAndUser: (values: InformationToUpdate) => {
  //   return protectedApiClient.put(`/Register/Update`, values);
  // }
};
